import { render, staticRenderFns } from "./EconomicCalculationForm.vue?vue&type=template&id=20e5e9b3&scoped=true&"
import script from "./EconomicCalculationForm.vue?vue&type=script&lang=ts&"
export * from "./EconomicCalculationForm.vue?vue&type=script&lang=ts&"
import style0 from "./EconomicCalculationForm.vue?vue&type=style&index=0&id=20e5e9b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5e9b3",
  null
  
)

export default component.exports